module.exports = __webpack_public_path__ + "img/Search Icon - charcoal.d9dc684b.svg";